import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { deliveryMethodText } from "./fulfillment-group-csv-helpers";

export const DeliveryMethodCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Delivery method",
    cell: (row) => {
      if (!row.deliveryMethod) {
        return "";
      }
      return deliveryMethodText[row.deliveryMethod];
    },
  };
